<template>
    <slider-with-input
        v-if="settingsAreAvailable"
        :value="investmentAmount"
        :input-formatter="inputFormatter"
        :min="minInvestmentAmount"
        :max="maxInvestmentAmountViaInput"
        :max-slider="maxInvestmentAmountViaSlider"
        :text="$t('investmentGoals.investmentAmount.text')"
        :textright="viewportIsLarge ? $t('investmentGoals.investmentAmount.minInvestmentAmount', { minInvestmentAmount:
            minInvestmentAmountFormatted }) : ''"
        :textleft="viewportNoMatch ? $t('investmentGoals.investmentAmount.minInvestmentAmount', { minInvestmentAmount:
            minInvestmentAmountFormatted }) : ''"
        :step="step"
        :force-numeric-keyboard="true"
        :mobile-text="$t('investmentGoals.investmentAmount.amount')"
        @valueChange="$emit('onInvestmentAmountChange', $event)"
        @valueChangeConfirmed="$emit('onInvestmentAmountChange', $event)" />
</template>

<script>
import { mapGetters } from 'vuex';
import SliderWithInput from '@/components/common/SliderWithInput';

export default {
    name: 'InvestmentGoalsAmount',
    components: {
        SliderWithInput,
    },
    data () {
        return {
            step: 1000,
            inputFormatter: {
                thousands: '’',
                prefix: 'CHF ',
            },
        };
    },
    props: {
        investmentAmount: {
            type: Number,
            required: false,
            default: null,
        },
    },
    computed: {
        ...mapGetters([
            'viewportNoMatch',
            'viewportIsLarge',
            'minInvestmentAmount',
            'maxInvestmentAmountViaInput',
            'maxInvestmentAmountViaSlider']),
        minInvestmentAmountFormatted () {
            return this.$options.filters.formatAmount(this.minInvestmentAmount);
        },
        settingsAreAvailable () {
            return this.minInvestmentAmount !== null && this.maxInvestmentAmountViaInput !== null && this.maxInvestmentAmountViaSlider !== null;
        },
    },
};
</script>
